import {Component, ElementRef, ViewChild} from '@angular/core';
import {NgForm, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {AdminTermsAndConditionsService} from './adminTermsAndConditions.service';

@Component({
  selector: 'adminTermsAndConditions-grid',
  templateUrl: './adminTermsAndConditions.component.html',
  providers: [AdminTermsAndConditionsService],
})
export class AdminTermsAndConditionsComponent extends BaseGridNoCookieComponent<AdminTermsAndConditionsService> {
  @ViewChild('termsModal') public termsModal: ModalDirective;
  @ViewChild('inputFile') myInputVariable: ElementRef;

  @ViewChild('confirmDeleteModal')
  public confirmDeleteModal: ModalDirective;
  fourEyes: boolean = false;
  fourEyesRequestId: string = '';
  foureyesComparisonId: number;
  public submiting: boolean = false;
  termsForm: UntypedFormGroup;
  inputFile: any;
  terms = [];
  term: any;
  differences: any;
  newFileName: any;
  newFileBase64: any;
  newFileExt: any;
  oldFileName: any;
  oldFileBase64: any;
  oldFileExt: any;
  error: any;
  isDisabled: boolean = false;
  isEditing: boolean = true;
  isSubmitted = false;
  isUpdating = false;
  viewRole: any;
  tagName: string;
  isCollapsed: boolean = true;

  constructor(
    public gridService: AdminTermsAndConditionsService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
    elem: ElementRef
  ) {
    super(securityService, logger, visualsService, gridService, 'newTerms');
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.viewRole = this.securityService.isOtherStaff();
    this.loadVisuals();
    this.buildForm();
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }

  ngOnInit() {
    this.getTermsAndConditionsList();
  }

  ngAfterViewInit() {
    if (this.fourEyes) {
      this.isUpdating = true;
      this.getFourEyesRequest();
    }
  }

  buildForm() {
    this.termsForm = this.fb.group({
      termsCode: ['', [Validators.required]],
      termsDescription: ['', [Validators.required]],
      termsFile: ['', Validators.required],
      filename: [''],
      ext: [''],
      fileLocation: [''],
    });
  }

  buildTermsForm(terms) {
    this.termsForm = this.fb.group({
      termsCode: [{value:terms?.termsCode,disabled: this.fourEyes}, [Validators.required]],
      termsDescription: [{value:terms?.termsDescription,disabled: this.fourEyes}, [Validators.required]],
      termsFile: [terms?.termsFile, Validators.required],
      filename: [terms?.filename],
      ext: [terms?.ext],
      fileLocation: [terms?.fileLocation],
    });
  }

  clearFileUploader() {
    this.myInputVariable.nativeElement.value = '';
    // this.termsForm.controls.termsFile.setValue(null);
    // this.termsForm.controls.filename.setValue(null);
    // this.termsForm.controls.ext.setValue(null);
  }

  downloadFile() {
    const linkSource = `data:application/pdf;base64,${this.oldFileBase64}`;
    const downloadLink = document.createElement('a');
    const fileName = this.oldFileName + this.oldFileExt;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadFourEyesFile() {
    const linkSource = `data:application/pdf;base64,${this.newFileBase64}`;
    const downloadLink = document.createElement('a');
    const fileName = this.newFileName + this.newFileExt;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    let size = e.target.files[0].size;
    if (size >= 5242880) {
      this.error = 'Maximum upload size exceeded. Allowed up to 5 MB';
      LogService.emitAlert({
        type: 'error',
        body: this.error,
      });
      this.clearFileUploader();
      return;
    } else {
      this.error = '';
    }
    var reader = new FileReader();
    const name = e.target.files[0].name;
    const lastDot = name.lastIndexOf('.');
    const fileName = name.substring(0, lastDot);
    const ext = '.' + name.substring(lastDot + 1);
    this.termsForm.patchValue({filename: fileName});
    this.termsForm.patchValue({ext: ext});
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    var reader = e.target;
    this.inputFile = reader.result;
    let base64result = reader.result.split(',')[1];
    this.termsForm.patchValue({termsFile: base64result});
  }

  getTermsAndConditionsList() {
    this.loading = true;
    this.isEditing = false;
    this.gridService.getTermsAndConditionsList().subscribe({
      next: (data) => {
        this.terms = data.data;
        this.loading = false;
      },
      error: (error) => {
        this.terms = [];
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  updateTerms(termsCode) {
    this.isUpdating = true;
    this.getTermsByTermsCode(termsCode);
  }

  getTermsByTermsCode(termsCode) {
    this.loading = true;
    this.isEditing = false;
    termsCode = encodeURIComponent(termsCode);
    this.gridService.getTermsAndConditionsByTermsCode(termsCode).subscribe({
      next: (data) => {
        this.term = data.data;
        this.oldFileBase64 = this.term.termsFile;
        this.oldFileName = this.term.filename;
        this.oldFileExt = this.term.ext;
        this.loading = false;
        this.buildTermsForm(this.term);
        this.termsModal.show();
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });

  }

  private getFourEyesRequest() {
    this.gridService.get4eyesRequest(this.fourEyesRequestId).subscribe({
      next: (data) => {
        this.term = JSON.parse(data.data.oldJsonRec);
        this.differences = data.data.differences;
        this.oldFileBase64 = this.term?.termsFile;
        this.oldFileName = this.term?.filename;
        this.oldFileExt = this.term?.ext;
        this.newFileBase64 = this.differences?.termsFile?.rightValue ?? this.oldFileBase64;
        this.newFileName = this.differences?.filename?.rightValue ?? this.oldFileName;
        this.newFileExt = this.differences?.ext?.rightValue ?? this.oldFileExt;
        this.loading = false;
        this.buildTermsForm(this.term);
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  deleteTerms(termsCode) {
    this.isEditing = false;
    termsCode = encodeURIComponent(termsCode);

    this.gridService.deleteTerms(termsCode).subscribe({
      next: (data) => {
        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
        this.getTermsAndConditionsList();
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  openModalForm() {
    this.isDisabled = false;
    this.isSubmitted = false;
    this.isEditing = false;
    this.loading = false;
    this.myInputVariable.nativeElement.value = '';
    this.termsModal.show();
  }

  openNewModal() {
    this.isUpdating = false;
    this.openModalForm();
  }

  checkTerms(id) {
    this.loading = true;

    this.gridService.checkTerms(id).subscribe({
      next: (data) => {
        if (data.success == false) {
          LogService.emitAlert({
            type: 'error',
            body: data.message,
          });
        } else {
          this.deleteTerms(id);
        }
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
    //this.getTermsAndConditionsList()
  }

  onSubmit(terms?: NgForm) {
    this.isSubmitted = true;
    if(!this.myInputVariable.nativeElement.value){
      this.termsForm.controls['termsFile'].setErrors({ required: true});
      return;
    }
    this.isUpdating = false;
    if (this.termsForm.valid) {
      this.loading = true;

      this.gridService.saveTerms(this.termsForm.value).subscribe({
        next: (data) => {
          LogService.emitAlert({
            type: 'success',
            body: data.message,
          });
          this.getTermsAndConditionsList();
          this.termsForm.reset();
          this.isSubmitted = false;
        },
        error: (error) => {
          this.logger.info(error);
          this.loading = false;
        },
      });
      this.termsModal.hide();
    } else {
      this.loading = false;
      return;
    }
  }
}
